export default {
  review: [],
  reviewForm: [],
  user: [],
  comment: [],
};
